(function () {
  function isMobileMedia() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function syncVideoPoster(video) {
    if (!video) return;

    var host = video.closest('[data-responsive-video-poster]');
    if (!host) return;

    var poster = isMobileMedia()
      ? host.dataset.mobilePoster || host.dataset.poster || ''
      : host.dataset.poster || '';

    if (poster && video.getAttribute('poster') !== poster) {
      video.setAttribute('poster', poster);
    }
  }

  function loadVideo(video) {
    if (!video) return;

    var didAttachSource = false;

    syncVideoPoster(video);
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'auto';

    if (video.dataset.src && !video.getAttribute('src')) {
      video.setAttribute('src', video.dataset.src);
      didAttachSource = true;
    }

    Array.prototype.slice.call(video.querySelectorAll('source')).forEach(function (source) {
      if (source.dataset.src && !source.getAttribute('src')) {
        source.setAttribute('src', source.dataset.src);
        didAttachSource = true;
      }
    });

    if (didAttachSource || video.readyState === 0) {
      video.load();
    }
  }

  function playVideo(video) {
    loadVideo(video);

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function initAceiiAiCoachMedia(root) {
    var sections = root.querySelectorAll(
      '[id^="AceiiSection-"] [data-aceii-ai-coach]'
    );

    sections.forEach(function (section) {
      if (section.dataset.mediaInitialized === 'true') return;

      section.dataset.mediaInitialized = 'true';

      var mediaItems = section.querySelectorAll(
        '.ai-coach-main-media, .ai-coach-card-media'
      );
      var videos = Array.prototype.slice.call(section.querySelectorAll('video'));
      var isSectionActive = false;

      videos.forEach(syncVideoPoster);

      mediaItems.forEach(function (media) {
        var card = media.closest('.ai-coach-main-card, .ai-coach-card');
        if (!card) return;

        function markLoaded() {
          card.classList.add('is-media-loaded');
        }

        if (media.tagName.toLowerCase() === 'img') {
          if (media.complete) {
            markLoaded();
          } else {
            media.addEventListener('load', markLoaded, { once: true });
            media.addEventListener('error', markLoaded, { once: true });
          }
        }

        if (media.tagName.toLowerCase() === 'video') {
          media.addEventListener('loadeddata', markLoaded, { once: true });
          media.addEventListener('canplay', markLoaded, { once: true });

          if (media.readyState >= 2) markLoaded();
        }
      });

      function playVideos() {
        if (document.hidden) return;

        videos.forEach(playVideo);
      }

      function pauseVideos() {
        videos.forEach(function (video) {
          video.pause();
        });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseVideos();
        } else if (isSectionActive) {
          playVideos();
        }
      });

      window.addEventListener('resize', function () {
        videos.forEach(syncVideoPoster);
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            isSectionActive = entry.isIntersecting;

            if (isSectionActive) {
              playVideos();
            } else {
              pauseVideos();
            }
          });
        }, {
          root: null,
          rootMargin: '300px 0px',
          threshold: 0.01
        });

        observer.observe(section);
      } else {
        isSectionActive = true;
        playVideos();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAceiiAiCoachMedia(document);
    });
  } else {
    initAceiiAiCoachMedia(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAceiiAiCoachMedia(event.target);
  });
})();
